export default "__VITE_ASSET__BUCKpSRg__"